import type { MutationConfig } from "apps/visits/core/lib/react-query";
import type { AxiosError } from "axios";
import { useMutation } from "react-query";
import { useGetSlug } from "../store/use-config";
import { GroupActionsOrderingRepository } from "./group-actions-ordering.api";
import type { VerifyPhoneNumberErrorResponse } from "./group-actions-ordering.types";

const groupActionsOrderingRepository = new GroupActionsOrderingRepository();

type UseVerifyPhoneNumberOptions = {
  config?: MutationConfig<
    typeof groupActionsOrderingRepository.verifyPhoneNumber,
    AxiosError<VerifyPhoneNumberErrorResponse>
  >;
};

export const useVerifyPhoneNumber = ({ config }: UseVerifyPhoneNumberOptions) => {
  const slug = useGetSlug();

  return useMutation({
    ...config,
    mutationFn: (data) => groupActionsOrderingRepository.verifyPhoneNumber(data, slug),
  });
};
